<div mat-dialog-container class="scrollable-dialog">

  <div mat-dialog-title style="display: flex; flex-direction: row;">
    <div class="dialog-header" fxFlex="" fxLayout="end">Neuer Batchvorgang (Gesamtlast/Abwurfpunkte)</div>
    <div class="close" style="margin-left: auto;">
      <button data-qa="batch_close-dialog-button" (click)="this.dialogRef.close();" type="button" [disabled]="uploading"
              matMiniFab>
        <mat-icon svgIcon="innogy_picto_close"></mat-icon>
      </button>
    </div>
  </div>

  <mat-stepper linear #stepper>
    <mat-step [stepControl]="firstFormGroup" [editable]="isEditable">
      <form [formGroup]="firstFormGroup" data-qa="batch-dialog-first-step-tab">
        <ng-template matStepLabel>Typ</ng-template>

        <mat-form-field id="initial-choose-vorgangsTyp-form-field">
          <mat-label>Vorgangstyp</mat-label>
          <mat-select
            formControlName="type"
            id="batchVorgangType"
            required>
            @for (type of vorgangsTyps; track type) {
              <mat-option
                [value]=type>{{ type | aufgabeTypeReadable }}
              </mat-option>
            }
          </mat-select>
          <mat-error>
            Bitte wählen Sie einen Typ aus
          </mat-error>
        </mat-form-field>
        <div mat-dialog-actions>
          <div fxFlex fxLayoutAlign="end" fxLayoutGap="1rem">
            <button class="actionbutton"
                    [disabled]="this.firstFormGroup.invalid" matButton="filled" matStepperNext>
              <mat-icon svgIcon="innogy_picto_arrow-right"></mat-icon>
              Weiter
            </button>
          </div>
        </div>
      </form>
    </mat-step>

    <mat-step [stepControl]="secondFormGroup" [editable]="isEditable">
      <form [formGroup]="secondFormGroup" data-qa="batch-dialog-second-step-tab">
        <ng-template matStepLabel>Details</ng-template>

        <div class="flex-col">
          <mat-form-field class="name-der-aufgabe">
            <input
              formControlName="name"
              id="baufgabeName"
              matInput
              maxLength="60"
              name="name"
              placeholder="Name"
              required/>
            <mat-hint align="end">{{ secondFormGroup.controls['name']?.value?.length }} / 60</mat-hint>
            @if (secondFormGroup.controls['name']?.errors?.required) {
              <mat-error>
                Bitte vergeben Sie einen eindeutigen Namen
              </mat-error>
            }
          </mat-form-field>

          <div class="item">
            <mat-form-field (click)="picker.open()">
              <input
                [matDatepicker]="picker"
                [min]="minFristDate"
                formControlName="frist"
                id="frist"
                matInput
                name="frist"
                required/>
              <mat-label>
                {{ firstFormGroup.controls['type'].value !== vorgangsTyps[2] ? 'Datum' : 'Frist' }}
              </mat-label>

              <mat-datepicker-toggle [for]="picker" matSuffix>
                <mat-icon matDatepickerToggleIcon svgIcon="innogy_picto_calendar-date-year"></mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>

              @if (secondFormGroup.controls['frist']?.errors?.required) {
                <mat-error>
                  Bitte wählen Sie eine Frist / ein Datum aus
                </mat-error>
              }
            </mat-form-field>
          </div>

          <mat-form-field>
          <textarea
            #autosize="cdkTextareaAutosize"
            cdkAutosizeMaxRows="4"
            cdkAutosizeMinRows="2"
            cdkTextareaAutosize
            formControlName="kurzbeschreibung"
            id="aufgabeKurzbeschreibung"
            matInput
            maxlength="1000"
            name="kurzbeschreibung"
            data-qa="kurzbeschreibung-textarea"
            placeholder="Kurzbeschreibung"></textarea>
            <mat-hint align="end">{{ secondFormGroup.controls['kurzbeschreibung']?.value?.length }} / 1000
            </mat-hint>
          </mat-form-field>
        </div>

        <div class="email-toggles">
          <div>
            <div class="toggle-info-text">Möchten Sie nach Abschluss des Vorganges benachrichtigt werden?</div>
            <mat-slide-toggle formControlName="emailBenachrichtigungNachVorgangabschluss"
                              id="benachrichtigungNachAbschluss"
                              name="emailBenachrichtigungNachVorgangabschluss">
              @if (secondFormGroup.controls['emailBenachrichtigungNachVorgangabschluss'].value) {
                <mat-label
                >
                  Ja
                </mat-label>
              } @else {
                <mat-label>Nein</mat-label>
              }
            </mat-slide-toggle>
          </div>
        </div>

        <div class="email-toggles">
          <div>
            <div class="toggle-info-text">E-Mail Benachrichtigung beim Anlegen und Löschen?</div>
            <mat-slide-toggle formControlName="emailBenachrichtigungSenden"
                              data-qa="batch_emailBenachrichtigungSenden"
                              name="emailBenachrichtigungSenden" (change)="toggledEmailBenachrichtigungSenden($event)">
              @if (secondFormGroup.controls['emailBenachrichtigungSenden'].value) {
                <mat-label
                >
                  Ja
                </mat-label>
              } @else {
                <mat-label>Nein</mat-label>
              }
            </mat-slide-toggle>
          </div>

          <div>
            <div class="toggle-info-text">E-Mail Erinnerung 30 und 7 Tage vor erreichen der Frist / des Datums senden?
            </div>
            <mat-slide-toggle formControlName="erinnerungsMailSenden" data-qa="batch_erinnerungsMailSenden"
                              name="erinnerungsMailSenden">
              @if (secondFormGroup.controls['erinnerungsMailSenden'].value) {
                <mat-label
                >
                  Ja
                </mat-label>
              } @else {
                <mat-label>Nein</mat-label>
              }
            </mat-slide-toggle>
          </div>
        </div>

        <div mat-dialog-actions>
          <div fxFlex fxLayoutAlign="end" fxLayoutGap="1rem">
            <button class="actionbutton"
                    matButton="outlined" matStepperPrevious>
              <mat-icon svgIcon="innogy_picto_arrow-left"></mat-icon>
              Zurück
            </button>
            <button [disabled]="this.secondFormGroup.invalid" class="actionbutton"
                    matButton="filled" matStepperNext>
              <mat-icon svgIcon="innogy_picto_arrow-right"></mat-icon>
              Weiter
            </button>
          </div>
        </div>
      </form>
    </mat-step>

    <mat-step [stepControl]="thirdFormGroup" [editable]="isEditable">
      <form [formGroup]="thirdFormGroup" data-qa="batch-dialog-third-step-tab">

        @if (!uploading) {
          <ufla-file-upload [multiple]="true"
                            [validators]="fileValidatorOptions"
                            formControlName="eonFile">
            @if (isFileSizeError()) {
              <mat-error>Die ausgewählte Datei ist zu groß, die maximale Größe beträgt 150MB.</mat-error>
            }
            @if (isFileRequiredError()) {
              <mat-error>Datei ist erforderlich.</mat-error>
            }
            @for (error of invalidFileErrorMessages; track error) {
              <mat-error>{{ error }}</mat-error>
            }
          </ufla-file-upload>
        }

        <ng-template matStepLabel>Dateien</ng-template>

        <div mat-dialog-actions>
          <div fxFlex fxLayoutAlign="end" fxLayoutGap="1rem">
            <button class="actionbutton"
                    matButton="outlined" matStepperPrevious>
              <mat-icon svgIcon="innogy_picto_arrow-left"></mat-icon>
              Zurück
            </button>
            <button [disabled]="this.thirdFormGroup.invalid || this.thirdFormGroup.pending" class="actionbutton"
                    matButton="filled" matStepperNext>
              <mat-icon svgIcon="innogy_picto_arrow-right"></mat-icon>
              Weiter
            </button>
          </div>
        </div>
      </form>
    </mat-step>

    <mat-step [stepControl]="fourthFormGroup" [editable]="isEditable">
      <form [formGroup]="fourthFormGroup" data-qa="batch-dialog-fourth-step-tab">
        <ng-template matStepLabel>Zuweisungen</ng-template>

        <ng-container formArrayName="useFileCheckboxes">
          @if (this.invalidFileNamesOrgNotFound.length > 0) {
            <table style="margin-bottom: 16px">
              <th><span class="warn-color" data-qa="org-not-found-header">Dateien für die keine Organisation gefunden wurde:</span>
              </th>
              <tr>
                <td [colSpan]="2">
                  <span>{{ invalidFileNamesOrgNotFound?.join(',') }}</span>
                </td>
              </tr>
            </table>
          }
          <table>
            <th colspan="2" style="text-align: start;">Organisationen, die zugewiesen sind (grau = Zuweisung deaktiviert)</th>
            @for (useFileCheckbox of useFileCheckboxes.controls; track useFileCheckbox; let index = $index) {
              <tr>
                <td>{{ controlIndexOrgMap.get(index).name }}: {{ controlIndexOrgMap.get(index).eicNummer }}
                </td>
                <td>
                  <div [formGroupName]="index">
                    <mat-checkbox
                      color="primary"
                      formControlName="useFileCheckbox"
                      id="neuerVorgang_{{index}}"
                      name="neuerVorgang">Datei: {{ selectedValidFiles[index] }}
                    </mat-checkbox>
                  </div>
                </td>
              </tr>
            }
          </table>
        </ng-container>

        <div mat-dialog-actions>
          <div fxFlex fxLayoutAlign="end" fxLayoutGap="1rem">
            <button class="actionbutton"
                    matButton="outlined" matStepperPrevious>
              <mat-icon svgIcon="innogy_picto_arrow-left"></mat-icon>
              Zurück
            </button>
            <button [disabled]="this.fourthFormGroup.invalid || this.invalidFileNamesOrgNotFound.length > 0"
                    class="actionbutton"
                    matButton="filled" matStepperNext>
              <mat-icon svgIcon="innogy_picto_arrow-right"></mat-icon>
              Weiter
            </button>
          </div>
        </div>
      </form>
    </mat-step>

    <mat-step>
      <form (ngSubmit)="saveAufgabe()" data-qa="batch-dialog-fifth-step-tab">
        <ng-template matStepLabel>Zusammenfassung</ng-template>
        <ufla-aufgabe-card [aufgabe]="neuerVorgang"
                           class="not-clickable"
        >
        </ufla-aufgabe-card>

        <div mat-dialog-actions>
          <div fxFlex fxLayoutAlign="end" fxLayoutGap="1rem">
            <button matButton="outlined" matStepperPrevious [disabled]="uploading">
              <mat-icon svgIcon="innogy_picto_arrow-left"></mat-icon>
              Zurück
            </button>
            <button
              [disabled]="!fourthFormGroup.valid"
              class="actionbutton"
              id="saveAufgabeButton"
              type="submit"
              matButton="filled">
              <mat-icon svgIcon="innogy_picto_check"></mat-icon>
              Speichern
            </button>
          </div>
        </div>
        @if (uploading) {
          <div>
            <mat-label class="padding-left">Lade hoch...</mat-label>
            <mat-progress-bar [value]="uploadProgress" mode="determinate"></mat-progress-bar>
            @if (numberOfFilesToUpload > 1) {
              <div>{{ numberOfUploadedFiles }} von {{ numberOfFilesToUpload }}</div>
            }
          </div>
        }
      </form>
    </mat-step>
  </mat-stepper>

  <ng-template #errorDialog>
    <h2 matDialogTitle>
      <mat-icon color='warn'>error</mat-icon>
      Fehler
    </h2>
    @if (errorMessage) {
      <p>{{ errorMessage }}</p>
    }
    <p matDialogContent>Änderungen konnten nicht gespeichert werden!</p>
    <mat-dialog-actions>
      <button matButton="filled" matDialogClose (click)="closeErrorDialog()">
        <mat-icon svgIcon="innogy_picto_check">
        </mat-icon>
        Verstanden
      </button>
    </mat-dialog-actions>
  </ng-template>

</div>
